import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Account } from './Accounts';
import { FiresContextProvider } from './contexts/FiresContext';
import { PanelContextProvider } from './contexts/PanelContext';
import { UserContextProvider } from './contexts/UserContext';
import { AlertsContextProvider } from './contexts/AlertsContext';
import { AreasContextProvider } from './contexts/AreasContext';
import { PredictionsContextProvider } from './contexts/PredictionsContext';
import { SensorDataContextProvider } from './contexts/SensorDataContext';
import { FacilitiesContextProvider } from './contexts/FacilitiesContext';
import { TeamsContextProvider } from './contexts/TeamsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Account>
      <UserContextProvider>
        <PanelContextProvider>
            <TeamsContextProvider>
              <AreasContextProvider>
                <FacilitiesContextProvider>
                  <SensorDataContextProvider>
                    <AlertsContextProvider>
                      <PredictionsContextProvider>
                          <FiresContextProvider>
                            <App />
                          </FiresContextProvider>
                      </PredictionsContextProvider>
                    </AlertsContextProvider>
                  </SensorDataContextProvider>
                </FacilitiesContextProvider>
              </AreasContextProvider>
            </TeamsContextProvider>
        </PanelContextProvider>
      </UserContextProvider>
    </Account>
  </Router>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
